class RecipeTabs extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.triggerEls = this.querySelectorAll('[data-el="recipe-tabs.trigger"]');
    this.contentEls = this.querySelectorAll('[data-el="recipe-tabs.content"]');

    if (this.triggerEls.length < 2) return

    this.initialiseTabs()
  }

  initialiseTabs () {
    this.triggerEls.forEach(triggerEl => {
      triggerEl.addEventListener('click', this.handleTrigger.bind(this))
    })
  }

  handleTrigger = event => {
    this.triggerEls.forEach(triggerEl => triggerEl.setAttribute('aria-pressed', triggerEl === event.target))
    this.contentEls.forEach(contentEl => contentEl.setAttribute('aria-expanded', contentEl.dataset.recipeTabsContent === event.target.dataset.recipeTabsName))
  }
}

customElements.define('recipe-tabs', RecipeTabs)
